module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=KI - Kiribati.a6f1b475.svg";